import React from 'react';
import PropTypes from 'prop-types';
import { FiAlertCircle } from 'react-icons/fi';

import { Box, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

const alertStyles = () => ({
  boxAlert: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '16px',
    background: '#e8f4fd',
    borderRadius: '4px',

    '& .boxIcon': {
      display: 'flex',
      fontSize: '22px',
      marginRight: '12px',
    },

    '& div p': {
      marginTop: '8px',
      fontSize: '16px',
    },
  },
});

function AddressAlert(props) {
  const { classes } = props;

  return (
    <Box className={classes.boxAlert} mt={1}>
      <Box className="boxIcon">
        <FiAlertCircle color="#2196f3" />
      </Box>
      <Box fontSize={16}>
        <strong>Não é seu endereço?</strong>
        <Typography>
          Fique tranquilo! Antes de prosseguir com o agendamento solicite a
          alteração pelo{' '}
          <strong>{process.env.REACT_APP_CENTRAL_PHONE_NUMBER}</strong>
        </Typography>
      </Box>
    </Box>
  );
}

AddressAlert.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(alertStyles)(AddressAlert);
